import type { FiatFlow } from '@funkit/connect-core'
import { useEffect, useRef, useState } from 'react'

import type { FiatOtpScreenProps } from './FiatOtpScreen'

type OtpProps = Omit<FiatOtpScreenProps, 'onClose'>
interface Submission {
  props: OtpProps
  code: string
}

/** Hold the verified code briefly without delaying the server's next transition. */
export function useOtpReceipt(flow: FiatFlow) {
  const code = useRef('')
  const [submission, setSubmission] = useState<Submission>()
  const state = flow.stepResponse?.state
  const advanced =
    (state?.kind === 'QUOTE' && state.error === undefined) ||
    state?.kind === 'KYC' ||
    state?.kind === 'PAYMENT' ||
    state?.kind === 'ORDER' ||
    (state?.kind === 'SESSION_AUTH' &&
      submission !== undefined &&
      (state.channel === 'SMS_OTP') !== submission.props.isSms)
  const accepted =
    submission !== undefined &&
    advanced &&
    flow.phase !== 'EXITED' &&
    flow.phase !== 'RETRYABLE'

  useEffect(() => {
    if (!accepted) {
      return
    }
    const timer = setTimeout(() => setSubmission(undefined), 500)
    return () => clearTimeout(timer)
  }, [accepted])
  useEffect(() => {
    if (
      flow.phase === 'EXITED' ||
      flow.phase === 'RETRYABLE' ||
      (state?.kind === 'SESSION_AUTH' && state.error !== undefined)
    ) {
      setSubmission(undefined)
    }
  }, [flow.phase, state])

  const bind = (props: OtpProps): OtpProps => ({
    ...props,
    onChangeCode: (next) => {
      code.current = next
      props.onChangeCode(next)
    },
    onSubmit: () => {
      setSubmission({ props, code: code.current })
      props.onSubmit()
    },
  })
  return { bind, receipt: accepted ? submission : undefined }
}
